import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useFetchSendOwnerInviteTemplate from 'components/domain/owner/useFetchSendOwnerInviteTemplate';
import FormWithProvider from 'components/forms/form/Form';
import useAppUser from 'hooks/useAppUser';
import { PropertyOwner } from 'models/Owner';
import {
  SendOwnerInviteSchemaFormValues,
  getFormDefaultValues,
  sendOwnerInviteSchema,
} from './SendOwnerInviteModal.schema';
import SendOwnerInviteModalFooter from './SendOwnerInviteModalFooter';
import SendOwnerInviteModalFormElements from './SendOwnerInviteModalFormElements';
import SendOwnerInviteModalLoadingPlaceholder from './SendOwnerInviteModalLoadingPlaceholder';

const SendOwnerInviteModal = ({
  owner,
  onSubmit,
  onClose,
}: {
  owner: PropertyOwner;
  onSubmit: (values: SendOwnerInviteSchemaFormValues) => void;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { agency } = useAppUser();
  const { data: template, isLoading } = useFetchSendOwnerInviteTemplate({
    ownerUid: owner.uid,
  });

  if (isLoading) {
    return <SendOwnerInviteModalLoadingPlaceholder onClose={onClose} />;
  }

  return (
    <FormWithProvider
      horizontal
      onSubmit={onSubmit}
      defaultValues={getFormDefaultValues({
        agencyName: agency?.name ?? '',
        owner,
        template,
      })}
      resolver={sendOwnerInviteSchema({ t })}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('pageProperty.owners.inviteModal.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SendOwnerInviteModalFormElements />
      </Modal.Body>

      <SendOwnerInviteModalFooter isLoading={isLoading} onClose={onClose} />
    </FormWithProvider>
  );
};

export default SendOwnerInviteModal;
